import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

interface UploadFileProps {
  ticketId: number
  attachmentType: string
  formData: FormData
}

export const uploadFile = async ({
  ticketId,
  attachmentType,
  formData,
}: UploadFileProps) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/attachment/save?ticketId=${ticketId}&attachmentType=${attachmentType}`,
      formData,
    )
    return response
  } catch (error) {
    console.error('Error syncing area:', error)
    throw error
  }
}
